import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  DescriptionStyles,
} from "./full-width-slider-styles"

export const SectionWrapper = styled.section`
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  & > * {
    max-width: 544px;
  }
  ${ContentWrapperStyles}
`

export const Description = styled.p`
  ${DescriptionStyles}
`
